import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61f94f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-name mb-4" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "price-list-name mb-3" }
const _hoisted_4 = { class: "row row-settings mb-4" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_7 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "settings", -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-xxl-4 mb-3 mb-xl-0" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-7 col-xl-5 col-xxl-12" }
const _hoisted_13 = { class: "d-flex flex-row align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "col-5 col-xl-3 col-xxl-12" }
const _hoisted_17 = { class: "col-12 col-xxl-8" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-8" }
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = { class: "product-card border border-1 rounded mx-auto" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "d-inline-block mt-3 pt-4 border-top border-2 border-light" }
const _hoisted_26 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_alert_success = _resolveComponent("alert-success")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_date = _resolveComponent("input-date")!
  const _component_discount_pricelist_section = _resolveComponent("discount-pricelist-section")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_input_radio = _resolveComponent("input-radio")!
  const _component_dp_error_message = _resolveComponent("dp-error-message")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_i18n_input_text_editor = _resolveComponent("i18n-input-text-editor")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('priceList'),
          mode: _ctx.mode,
          "help-text": _ctx.$t('descriptionPriceListsDetail'),
          "back-route": {name: _ctx.returnRoute},
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, null, 8, ["title", "mode", "help-text", "back-route", "onRefresh"]),
        _createVNode(_component_alert_success, {
          "show-if": _ctx.savedSuccessfully,
          class: "mb-3"
        }, null, 8, ["show-if"]),
        _createVNode(_component_alert_error, {
          exceptions: _ctx.exceptions,
          class: "mb-3"
        }, null, 8, ["exceptions"]),
        (!_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_dp_form, {
              key: 1,
              as: "form",
              onSubmit: _ctx.submitData,
              novalidate: ""
            }, {
              default: _withCtx(({ errors }) => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("section", _hoisted_3, [
                      _createVNode(_component_input_text, {
                        modelValue: _ctx.priceList.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.priceList.name) = $event)),
                        modelModifiers: { trim: true },
                        label: _ctx.$t('name'),
                        name: "name",
                        rules: "required|max:100",
                        errors: errors
                      }, null, 8, ["modelValue", "label", "errors"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h2", _hoisted_7, [
                        _hoisted_8,
                        _createTextVNode(_toDisplayString(_ctx.$t('discountSettings')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_discount_pricelist_section, {
                                class: "discount-period mb-3",
                                title: _ctx.$t('period'),
                                icon: "date_range"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_input_date, {
                                      label: _ctx.$t('begin'),
                                      placeholder: "DD-MM-JJJJ",
                                      name: _ctx.$t('begin'),
                                      modelValue: _ctx.priceList.begin_date,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.priceList.begin_date) = $event)),
                                      rules: "required",
                                      class: "me-3",
                                      errors: errors
                                    }, null, 8, ["label", "name", "modelValue", "errors"]),
                                    _createVNode(_component_input_date, {
                                      label: _ctx.$t('end'),
                                      placeholder: "DD-MM-JJJJ",
                                      name: _ctx.$t('end'),
                                      modelValue: _ctx.priceList.end_date,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.priceList.end_date) = $event)),
                                      rules: "check_date:@begin,@end",
                                      class: "me-3",
                                      errors: errors
                                    }, null, 8, ["label", "name", "modelValue", "errors"]),
                                    (_ctx.priceList.end_date)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.clearPriceListPeriod()), ["prevent"])),
                                          class: "btn btn-icon btn-sm mb-3"
                                        }, _hoisted_15))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_discount_pricelist_section, {
                                class: "discount-client-group",
                                title: _ctx.$t('clientGroup'),
                                icon: "group"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_input_select, {
                                    modelValue: _ctx.priceList.client_group_code,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.priceList.client_group_code) = $event)),
                                    name: _ctx.$t('clientGroup'),
                                    options: _ctx.clientGroups,
                                    errors: errors
                                  }, null, 8, ["modelValue", "name", "options", "errors"])
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_discount_pricelist_section, {
                                class: "discount-show pb-2 mb-3",
                                title: _ctx.$t('discountShowAsFollows'),
                                icon: "visibility"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_input_radio, {
                                    id: "discountDontShow",
                                    label: _ctx.$t('discountDontShow'),
                                    name: _ctx.$t('discountShowAsFollows'),
                                    errors: errors,
                                    rules: "required",
                                    value: "none",
                                    modelValue: _ctx.selectedDiscountOption,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedDiscountOption) = $event))
                                  }, null, 8, ["label", "name", "errors", "modelValue"]),
                                  _createVNode(_component_input_radio, {
                                    id: "discountShowPriceOnly",
                                    label: _ctx.$t('discountShowPriceOnly'),
                                    name: _ctx.$t('discountShowAsFollows'),
                                    errors: errors,
                                    rules: "required",
                                    value: "price",
                                    modelValue: _ctx.selectedDiscountOption,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedDiscountOption) = $event))
                                  }, null, 8, ["label", "name", "errors", "modelValue"]),
                                  _createVNode(_component_input_radio, {
                                    id: "discountShowPriceAndPercent",
                                    label: _ctx.$t('discountShowPriceAndPercent'),
                                    name: _ctx.$t('discountShowAsFollows'),
                                    errors: errors,
                                    rules: "required",
                                    value: "pricePercent",
                                    modelValue: _ctx.selectedDiscountOption,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDiscountOption) = $event))
                                  }, null, 8, ["label", "name", "errors", "modelValue"]),
                                  _createVNode(_component_dp_error_message, {
                                    class: "invalid-feedback d-block",
                                    name: _ctx.$t('discountShowAsFollows')
                                  }, null, 8, ["name"])
                                ]),
                                _: 2
                              }, 1032, ["title"]),
                              _createVNode(_component_discount_pricelist_section, {
                                class: "discount-message pb-3",
                                title: _ctx.$t('discountMessage'),
                                icon: "chat"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_MultilingualSwitcher, {
                                    errors: errors,
                                    "active-language": _ctx.activeLanguage,
                                    mb: 2,
                                    onUpdateActiveLanguage: _cache[8] || (_cache[8] = (newValue) => _ctx.activeLanguage = newValue)
                                  }, null, 8, ["errors", "active-language"]),
                                  _createVNode(_component_i18n_input_text_editor, {
                                    name: "discount_message",
                                    data: _ctx.priceList.discount_message,
                                    "active-language": _ctx.activeLanguage,
                                    errors: errors,
                                    "onUpdate:data": _ctx.discountMessageUpdated
                                  }, null, 8, ["data", "active-language", "errors", "onUpdate:data"])
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_discount_pricelist_section, { class: "discount-preview pb-3" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("img", {
                                      src: require('@/assets/images/product-card-discount/' + _ctx.selectedDiscountOptionImage),
                                      class: _normalizeClass(['top img-fluid w-100 rounded-top', {'opacity-50': _ctx.selectedDiscountOption === ''}]),
                                      alt: _ctx.$t('discountShowAsFollows')
                                    }, null, 10, _hoisted_22),
                                    (!_ctx.isEmptyString(_ctx.discountMessage[_ctx.activeLanguage]))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          innerHTML: _ctx.discountMessage[_ctx.activeLanguage],
                                          class: "discount-message-preview fst-italic p-2"
                                        }, null, 8, _hoisted_23))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("img", {
                                      src: require('@/assets/images/product-card-discount/' + _ctx.selectedDiscountOptionImage),
                                      class: _normalizeClass(['bottom img-fluid w-100 rounded-bottom', {'opacity-50': _ctx.selectedDiscountOption === ''}]),
                                      alt: _ctx.$t('discountShowAsFollows')
                                    }, null, 10, _hoisted_24)
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_input_select, {
                    modelValue: _ctx.priceList.status_code,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.priceList.status_code) = $event)),
                    name: "status",
                    selectText: _ctx.$t('selectText'),
                    options: _ctx.statusOptions,
                    rules: "required",
                    errors: errors
                  }, null, 8, ["modelValue", "selectText", "options", "errors"]),
                  _createElementVNode("button", _hoisted_26, _toDisplayString(_ctx.$t('save')), 1)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}